import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { UserDataService } from '../features/user-data.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
logged=false;
userSubs!:Subscription;

  constructor(private user:AuthService, private route:Router, private data:UserDataService) { }

  ngOnInit(): void {
  this.userSubs=this.user.user.subscribe(user=>{
    this.logged =!user? false: true;


  });
  }

  ngOnDestroy() {this.userSubs.unsubscribe()}
  logOut(){
    this.logged=false;
    this.user.logOut();
    this.route.navigate(["/"]);
  }


}
